// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3scxO","title":"ClientInsurance_title__24os_","itemText":"ClientInsurance_itemText__3T2b5"};